module.exports = __webpack_public_path__ + "static/craft-paper-8fe2d162d1602fe7a2e4a82fe74cad62.png";